import { h, Fragment, Component } from 'preact';
import { useEffect, useMemo, useRef, useState } from 'preact/hooks';

import { observer } from 'mobx-react';
import classNames from 'classnames';

import { Recommendation, useMediaQuery } from '@searchspring/snap-preact-components';
import { Result } from '../Result';

import './Recs.css';

import nextButton from './icon-right.svg';
import prevButton from './icon-left.svg';

const breakpoints = {
  0: {
    slidesPerView: 1.3,
    slidesPerGroup: 1,
    spaceBetween: 10,
  },
  450: {
    slidesPerView: 2.3,
    slidesPerGroup: 2,
    spaceBetween: 10,
  },
  750: {
    slidesPerView: 3.3,
    slidesPerGroup: 3,
    spaceBetween: 10,
  },
  990: {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 10,
  },
};

@observer
export class Recs extends Component {
  constructor(props) {
    super();

    const controller = props.controller;

    if (!controller.store.profile) {
      controller.init();
      controller.search();
    }
  }

  render() {
    let newController = this.props.controller;
    newController.store.config.globals = {
      ...newController.store.config.globals,
      ssConfig: window?.ssConfig,
    };

    return <RecsContent controller={this.props.controller} />;
  }
}

const RecsContent = ({ controller }) => {
  const recElement = useRef();

  const [heading, setHeading] = useState();
  const [headingSize, setHeadingSize] = useState();
  const [description, setDescription] = useState();
  const [descriptionSize, setDescriptionSize] = useState();

  const isMobile = useMediaQuery('(max-width: 989px)');
  const isDesktop = !isMobile;

  const store = controller?.store;
  const params = store.profile?.display?.templateParameters;

  // Grab heading and description from section settings
  useEffect(() => {
    const recommendationsElement = recElement?.current?.closest('.recommendations');
    setHeading(recommendationsElement?.dataset.heading);
    setHeadingSize(recommendationsElement?.dataset.headingSize);
    setDescription(recommendationsElement?.dataset.description);
    setDescriptionSize(recommendationsElement?.dataset.descriptionSize);
  }, []);

  const { hideBadge, hideBrand, hideProductLine, hidePromo, hideSwatches, maxProductsToShow } = useParams(params);

  return (
    <div className='ss__recs' ref={recElement}>
      <div className='page-width'>
        <div className='ss__recs-separator' />
      </div>
      <div className='ss__recs-header page-width'>
        {heading && <h2 className={`ss__recs-title ${headingSize}`}>{heading}</h2>}
        {description && <p className={`ss__recs-description ${descriptionSize}`}>{description}</p>}
      </div>
      <div className={classNames('ss__recs-carousel', { 'page-width': isDesktop })}>
        <Recommendation
          controller={controller}
          breakpoints={breakpoints}
          hideButtons={isMobile}
          loop={false}
          nextButton={
            <img
              className='ss__recs-carousel-arrow'
              src={nextButton}
              alt=''
              aria-label={window.Resources.searchspring.recommendations.ariaLabelNext}
            />
          }
          prevButton={
            <img
              className='ss__recs-carousel-arrow'
              src={prevButton}
              alt=''
              aria-label={window.Resources.searchspring.recommendations.ariaLabelPrev}
            />
          }
          observer
          observeParents
          threshold={10}
        >
          {store.results.map((result, i) => {
            return i < maxProductsToShow ? (
              <Result
                result={result}
                controller={controller}
                hideBadge={hideBadge === 'true'}
                hideBrand={hideBrand === 'true'}
                hideProductLine={hideProductLine === 'true'}
                hidePromo={hidePromo === 'true'}
                hideSwatches={hideSwatches === 'true'}
                isRecommendations={true}
              />
            ) : null;
          })}
        </Recommendation>
      </div>
    </div>
  );
};

const useParams = params => {
  return useMemo(() => {
    let {
      headerText,
      description,
      hideBadge,
      hideBrand,
      hideProductLine,
      hidePromo,
      hideSwatches,
      maxProductsToShow = 8,
    } = { ...params };

    hideBadge = hideBadge === 'true';
    hideBrand = hideBrand === 'true';
    hideProductLine = hideProductLine === 'true';
    hidePromo = hidePromo === 'true';
    hideSwatches = hideSwatches === 'true';
    maxProductsToShow = Number(maxProductsToShow);

    return {
      headerText,
      description,
      hideBadge,
      hideBrand,
      hideProductLine,
      hidePromo,
      hideSwatches,
      maxProductsToShow,
    };
  }, [params]);
};
